import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { Badge } from '../../../templates/models/badge.interface';
import * as moment from 'moment';
import { TranslatePipe } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { StudyTableService } from '../../../_services';
import { BaseComponent } from 'src/app/_base/base.component';
import { ScheduleCategoryAuto } from 'src/app/_models';
import { AcademicFilterComponent } from 'src/app/templates/academic-filter/academic-filter.component';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
@Component({
  selector: 'app-timetables',
  templateUrl: './timetables.component.html',
  styleUrls: ['./timetables.component.scss']
})
export class TimetablesComponent extends BaseComponent implements OnInit {
  @Input()
  dayDate: string = moment()
    .locale('en')
    .format('YYYY-MM-DD');
  @Input('showDays') showDays: boolean = true;
  badgeStatus: Badge[] = null;
  PageName: string = 'ClassModule.PageName';
  TableName: string = 'ClassModule.TableName';
  ListName: string = 'ClassModule.ListName';
  classId: number = null;
  sectionId: number = null;
  defaultImgUrl: string = '../../assets/Images/users/default-user.jpg';
  academic: AcademicFilterComponent;
  isEmpty: boolean;
  timetableobj: ScheduleCategoryAuto[] = [];
  CurrentWeek: Array<any>;
  week: Array<String>;
  configurations: PerfectScrollbarConfigInterface;
  Active: any;
  isActive: boolean = false;
  constructor(private activatedRoute: ActivatedRoute, private _timeTableService: StudyTableService) {
    super();

    // this.academicFilterService.filterNotefier.subscribe(data => {
    //   this.academic = data;
    //   this.academic.resetFilter();
    // });
  }

  ngOnInit() {
    this.initbage();
    this.getRouterParms();
  }
  initbage() {
    this.badgeStatus = [
      { id: 0, name: 'Date', value: this.dayDate, color: '#f2f2f2' },
      { id: 1, name: 'AcademicModule.GenerateScheduleClassTiming', value: this.timetableobj.length, color: '#f2f2f2' }
    ];
  }
  getRouterParms() {
    this.activatedRoute.queryParams.subscribe(parms => {
      this.classId = parseInt(parms['classId'], 10);
      this.sectionId = parseInt(parms['sectionId'], 10);
      this.dataInit();
    });
  }
  dataInit(): void {
    this.badgeStatus[0].value = this.dayDate;
    this.GetStudyTableByDate(this.classId, this.sectionId, this.dayDate);
  }
  dateUpdate(date: string | null): void {
    if (date) this.dayDate = date;
    else
      this.dayDate = moment()
        .locale('en')
        .format('YYYY-MM-DD');
    this.dataInit();
  }
  GetStudyTableByDate(classId: number, sectionId: number, date: string) {
    this.isActive = true;
    this._timeTableService.GetStudyTableByDate(classId, sectionId, date).subscribe(
      (data: ScheduleCategoryAuto[]) => {
        this.timetableobj = data;
        this.initbage();
        this.isActive = false;
      },
      () => {
        this.timetableobj = [];
        this.initbage();
        this.isActive = false;
      }
    );
  }
}
